import { render, staticRenderFns } from "./ExpressionEdit.vue?vue&type=template&id=6afa3e2c&scoped=true&"
import script from "./ExpressionEdit.vue?vue&type=script&lang=ts&"
export * from "./ExpressionEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ExpressionEdit.vue?vue&type=style&index=0&id=6afa3e2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afa3e2c",
  null
  
)

export default component.exports